export default __webpack_public_path__ + "static/media/word.94c70d17.svg";